var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"margin-left"},[_c('div',{staticClass:"detail text-left"},[_c('p',{staticClass:"fs22"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"margin-top-sm",domProps:{"innerHTML":_vm._s(_vm.body)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae71551","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my/feed/detail.vue
// module id = null
// module chunks = 